import React, {useEffect} from 'react';
import {styles} from "./index";
import useNotes from "@/app/features/home/components/notes/slice";

const NotesPage = () => {
  const {state} = useNotes();

  useEffect(() => {

  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.filters}></div>
      <div className={styles.main}></div>
    </div>
  );
}

export default NotesPage;